import { ExportType } from '@components'

import { type ExportDocumentFileType } from '@features/exports/types/exportDocumentFileType'

export const productsExportFileTypes: ExportDocumentFileType[] = [ExportType.Csv, ExportType.Xlsx]

export const defaultProductsExportFileType: ExportDocumentFileType = ExportType.Csv
